import React, { useState, useCallback, useEffect, useContext } from 'react'
import { isBrowser, isMobile } from 'react-device-detect';
import { useNavigate, useParams } from 'react-router-dom';
import { useFetch } from '../../api/FetchApiData';
import { useInfiniteScroll } from '../../utils/InfiniteScroll';
import { MediaUrl } from '../../utils/media/Media';
//import WsNotifications from '../../api/WsNotifications';
import { AppContext, UserContext } from '../../../AppContextProvider';
import Popup from 'reactjs-popup';
import Select from 'react-select';
import remove_icon from '../../icons/remove.webp';
import rikinaze_icon from '../../icons/rikinaze.webp';
import djamnazi_logo from '../../icons/djamnazi.webp';
import add_part_icon from '../../icons/add_participant.webp';


if (!isMobile)
    import('./conversations.css').then(() => {});
else
    import('./mob-conversations.css').then(() => {});



function Conversation({conversation, staffs, basUrl})
{
    const navigator = useNavigate();
    const [UserState,setUserState] = useContext(UserContext);
    const [conv,setConv] = useState(conversation);
    const fetchData = useFetch();

    let _logo = djamnazi_logo;
    if(conversation.client.role==='assistance')
        _logo = rikinaze_icon;
    else if(conversation.client.role === 'deliver')
        _logo = MediaUrl(conversation.client.logo.image);

    const HandleParticipantChance=(value,actionMeta)=>{
        if(actionMeta.action==="remove-value")
        {
            fetchData.DeleteData({conversation:conv.id,participant:actionMeta.removedValue.value},'user/participants/conversation/').then((result)=>{
                console.log(result)
            })
        }
        else if(actionMeta.action==="select-option")
        {
            fetchData.PutData({conversation:conv.id,participant:actionMeta.option.value},'user/participants/conversation/').then((result)=>{
                console.log(result)
            })
        }
    }

    const Delete_Conversation=()=>{

    }

    return(
    <div className='div-conversation'>
        <label style={{display:'block',fontSize:'small',fontWeight:'bold'}}>{conv.title}</label>
        <label style={{display:'block',fontSize:'small',color:'gray'}}>{conv.client.name}</label>
        {(conv.unread>0) && <label className='messages-counter'>{conv.unread}</label>}
        <div onClick={e=>{navigator(`${basUrl}/conversation/${conv.conversation_number}/`)}} style={{marginBottom:'10px'}}>
            <img className='conversation-image' src={_logo} />
            <label style={{display:'block',fontSize:'small',color:'gray'}}>{conv.service}</label>
            <label style={{display:'block',fontSize:'x-small',color:'gray'}}>{conv.datetime}</label>
        </div>
        <div style={{position:'absolute',left:'5px',bottom:'2px',paddingTop:'10px'}}>
            {(UserState.auth && UserState.is_staff && <img onClick={e=>{Delete_Conversation()}} src={remove_icon} style={{width:'20px',marginRight:'10px'}} />)}
            <Popup trigger={(UserState.auth && UserState.is_staff && <img src={add_part_icon} style={{width:'20px'}} />)}>
                {close=>(<div style={{textAlign:'center',position:'fixed',top:'0px',left:'0px',backgroundColor:'rgba(0,0,0,0.8)',width:'100%',height:'100vh'}}>
                    <fieldset style={{position:'relative',top:'25%',margin:'auto',backgroundColor:'white',borderRadius:'10px',width:'90%'}}>
                        <Select  name="participants"
                                isClearable = {false}
                                className="ajout-article-select"
                                isSearchable = {true}
                                onChange={(value,action)=>{
                                    console.log(value);HandleParticipantChance(value,action);
                                }}
                                onInputChange={(value,action)=>{HandleParticipantChance(value,action)}}
                                options={staffs}
                                defaultValue={conv.participants}
                                isMulti={true}
                        />
                        <div style={{position:'relative',textAlign:'center',width:'100%',margin:'auto', marginTop:'10px'}}>
                            <input onClick={e=>{close()}} type='button' value={'OK'} style={{display:'inline-block',height:'30px', width:'40%',border:'none',backgroundColor:'#FFCBCC'}}/>
                        </div>
                    </fieldset>
                </div>)}
            </Popup>
        </div>
    </div>   
    )
}

function ConversationsByType({order,basUrl,staffs,type='clients'})
{
    const [conversations,setConversations] = useState([]);
    const [page,setPage] = useState(1);
    const [hasMore,setHasMore] = useState(true);
    const fetchData = useFetch();

    const FetchConversations = useCallback(async ()=>{
        console.log('fetching ...');
        if (!hasMore)
            return
        let _order = order;
        if(_order===undefined)
            _order = 'all';
        fetchData.GetData(`user/conversations/${_order}/${page}/${type}/`).then((result)=>{
            if(result.result)
            {
                console.log(result);
                if(page>=result.max)
                    setHasMore(false);
                else
                {
                    setPage(prev=>prev+1);
                }
                setConversations([...conversations,...result.conversations]);
            }
        }).catch(error=>{console.log(error)});
        
    },[page, hasMore])

     const LoadMoreRef = useInfiniteScroll(FetchConversations,hasMore);

    return(
        <div style={{width:'100%',padding:'10px'}}>
            {  (conversations.length===0) &&
                <h3 style={{color:'gray'}}>
                    Aucune conversation trouvée
                </h3>
            }                                        
            {
                conversations.map((conv,index)=>{
                    return(
                        <Conversation key={index} conversation={conv} staffs={staffs} basUrl={basUrl} />
                    );})
            }
            <div ref={LoadMoreRef} style={{height:'20px'}}/>
        </div>);
}

function Conversations({close=()=>{},height='auto'}) {
    
    const fetchData = useFetch();
    const [basUrl,setBaseUrl] = useState('');
    const [staffs,setStaffs] = useState([]);
    const {order} = useParams();
    const [UserState,setUserState] = useContext(UserContext);
    const [btnsStates, setBtnsStates] = useState({'clients':false,'selfs':true});
    const [btnsTexts,setBtnsTexts] = useState({'clients':'+','selfs':'-'});

    useEffect(()=>{
        if(isBrowser)
            setBaseUrl('/user');
        fetchData.GetData(`user/staffs/`).then((result)=>{
            if(result.result)
            {
                setStaffs(result.staffs);
            }
        }).catch(error=>{console.log(error)});
    },[])

    useEffect(()=>{
        if(btnsStates.clients)
            setBtnsTexts({...btnsTexts,clients:'-'});
        else
            setBtnsTexts({...btnsTexts,clients:'+'});
    },[btnsStates.clients])

    useEffect(()=>{
        if(btnsStates.selfs)
            setBtnsTexts({...btnsTexts,selfs:'-'});
        else
            setBtnsTexts({...btnsTexts,selfs:'+'});
    },[btnsStates.selfs])

        return(
        <div id='div-conversations' style={{}}>
            <ConversationsByType basUrl={basUrl} staffs={staffs} order={order} type='selfs' />  
            {   /*
                (UserState.is_staff) &&
                <div>
                    <div style={{border:'1px solid lightgray',width:'90%',height:'30px',margin:'auto',borderRadius:'10px'}}>
                        <button onClick={e=>{setBtnsStates({...btnsStates,clients:!btnsStates.clients})}} style={{border:'none',borderTopLeftRadius:'10px',borderBottomLeftRadius:'10px',float:'inline-start',height:'30px',width:'50px'}}>{btnsTexts.clients}</button>
                        <h3 style={{border:'none',margin:'auto',paddingTop:'5px'}}>Conversations Clients</h3>
                    </div>
                    {(btnsStates.clients) && <ConversationsByType basUrl={basUrl} staffs={staffs} order={order} type='clients' />                    }
                </div>
            }
            {
            <div style={{marginTop:'5px'}}>
                <div style={{border:'1px solid lightgray',width:'90%',height:'30px',margin:'auto',borderRadius:'10px'}}>
                    <button onClick={e=>{setBtnsStates({...btnsStates,selfs:!btnsStates.selfs})}} style={{border:'none',borderTopLeftRadius:'10px',borderBottomLeftRadius:'10px',float:'inline-start',height:'30px',width:'50px'}}>{btnsTexts.selfs}</button>
                    <h3 style={{border:'none',margin:'auto',paddingTop:'5px'}}>Mes Conversations</h3>
                </div>
                {(btnsStates.selfs) && <ConversationsByType basUrl={basUrl} staffs={staffs} order={order} type='selfs' />                    }
            </div>
            */
            }
        </div>)
    //}
}

export default Conversations
